<crtz-header></crtz-header>
<crtz-error [error]="error"></crtz-error>
<router-outlet></router-outlet>
<crtz-modal-figital></crtz-modal-figital>
